/**
 * Three bezier connectors fanning one source out to stacked destinations
 * (the "send anywhere" tile). `anchorsY` are the destination centres within
 * the 80-unit column; `activeIndex` lights one connector in the primary
 * colour, `null` leaves them all quiet (reduced motion).
 */
export function FanOutLinesIcon({
  anchorsY,
  activeIndex,
  className,
}: {
  anchorsY: ReadonlyArray<number>
  activeIndex: number | null
  className?: string
}) {
  return (
    <svg
      viewBox="0 0 40 80"
      className={className}
      fill="none"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      {anchorsY.map((y, index) => (
        <path
          key={y}
          d={`M0 40 C 20 40, 20 ${y}, 40 ${y}`}
          stroke={index === activeIndex ? 'var(--primary)' : 'var(--border)'}
          strokeWidth={1.5}
          className="transition-[stroke] duration-300"
        />
      ))}
    </svg>
  )
}
